// @owner @Appboy/clip

import * as Sentry from "@sentry/browser";

const GEOLOCATION_URL = "https://ipinfo.io/country";
const TIMEOUT_MS = 30 * 1000;
const COUNTRY_CODE_UNKNOWN = "ZZ";

export const fetchCountryCode = async () => {
  return await window
    .fetch(GEOLOCATION_URL, {
      signal: AbortSignal.timeout(TIMEOUT_MS),
    })
    .then((response) => response.text())
    .then((countryCode) => countryCode.trim())
    .catch(() => {
      Sentry.captureMessage("[GEOLOCATION] Unable to determine impersonator's location");
      return COUNTRY_CODE_UNKNOWN;
    });
};
